<template>
    <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-card body-style="padding: 30px">
                <img class="img" src="../../../assets/img/cp/arm9.jpg" alt="">
                <div class="introduce">
                    <p class="inner_title">ARM 9 核心板</p>
                    <p class="s-detail">
                        主要包括：⑴无线网络设备：手机上网、电子邮件及其他定位服务等功能；⑵PDA功能：含有用户操作系统
                        (WindowsCE、SymbianOS、Linux等）及其他功能；⑶高性能功能：音频播放器、视频电话、手机游戏等。
                        <a href="#">[详情]</a>
                    </p>
                    <p class="end_title">钧飞智能科技有限公司出品</p>
                </div>
            </el-card>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-card body-style="padding: 30px">
                <img class="img" src="../../../assets/img/cp/armA9.jpg" alt="">
                <div class="introduce">
                    <p class="inner_title">Cortex-A9 核心板</p>
                    <p class="s-detail">
                        无与伦比的性能，2GHz 标准操作可提供 TSMC 40G 硬宏实现
                        以低功耗为目标的单核实现，面向成本敏感型设备
                        利用高级 MPCore 技术，最多可扩展为 4 个一致的内核
                        可选 NEON™ 媒体和/或浮点处理引擎。
                        <a href="#">[详情]</a>
                    </p>
                    <p class="end_title">钧飞智能科技有限公司出品</p>
                </div>
            </el-card>

        </el-col>
    </el-row>
</template>

<script>
  export default {}
</script>

<style src="../../../assets/css/smartModule.css" scoped>
    /*@import "../../assets/css/smartModule.css";*/
</style>
